export default __webpack_public_path__ + "static/media/bg-home.d91b7596.jpg";